import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxsModule } from '@ngxs/store';
import { CoreModule } from 'app/core/core.module';
import { CustomMaterialModule } from 'app/custom-material/custom-material.module';
import { GroupsRestService } from 'app/services/groups.rest.service';
import { GuidedTourModule } from 'ngx-guided-tour';
import { AddMembersDialogComponent, SearchUsersPipe } from './components/add-members-dialog/add-members-dialog.component';
import { CreateGroupDialogComponent } from './components/create-group-dialog/create-group-dialog.component';
import { ManagementComponent } from './components/management/management.component';
import { SavingGroupComponent } from './components/saving-group/saving-group.component';
import { GroupManagementRoutingModule } from './group-management-routing.module';
import { SearchGroupsPipe } from './pipes/search-groups.pipe';
import { GroupManagementState } from './state/group-management.state';

@NgModule({
  declarations: [
    ManagementComponent,
    SearchGroupsPipe,
    CreateGroupDialogComponent,
    AddMembersDialogComponent,
    SearchUsersPipe,
    SavingGroupComponent,
  ],
  imports: [
    CommonModule,
    CustomMaterialModule,
    BrowserModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    GroupManagementRoutingModule,
    ScrollingModule,
    NgxsModule.forFeature([GroupManagementState]),
    CoreModule,
    GuidedTourModule
  ],
  providers: [
    GroupsRestService
  ]
})
export class GroupManagementModule {}
